import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hg3vtct9kg: FaireBrandEntity = {
  token: "b_hg3vtct9kg",
  type: "brand",
  name: "Eleven Fashion",
  avatarUrl:
    "https://cdn.faire.com/fastly/deaf4042e5263e44563c07667bdbafd70ca1c78864e45cddfcf1a59316b53dbc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1a8130ab46cfcd6a22097c175fdd938665e447fe4f95257566f782540d37917a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/deaf4042e5263e44563c07667bdbafd70ca1c78864e45cddfcf1a59316b53dbc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1a8130ab46cfcd6a22097c175fdd938665e447fe4f95257566f782540d37917a.png",
  location: "Irvine, CA, USA",
  minimumOrderDollars: 50,
  rating: 4.5,
  reviewCount: 157,
  isInsider: true,
  description:
    "Elevate your style with Eleven Fashion! We specialize in printed shirts and chic apparel for women. Unleash your inner fashionista with our unique designs and quality pieces. Explore our collection and let your wardrobe make a statement. Elevate your fashion game with Eleven Fashion today!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:02.712Z",
    importedBy: "entity-db-cli",
  },
};
